module.exports = __webpack_public_path__ + "static/media/call_whisper_end.24c2ff9d.svg";